import authentication from "@irati/auth"
import {User, Reward, RewardOrder} from "@irati/types"
import {WhoRewardedRewardTypes, WhoRewardedVisibilityTypes, WhoRewardedTypes} from "@irati/reward/enums/WhoRewardedTypes"

export function getVisibilityType(): WhoRewardedVisibilityTypes {
  const isRewardHidden = authentication.apps("recognition.rewards.viewOff")
  const isRewardLimited = authentication.apps("recognition.rewards.viewLimited")

  if (isRewardHidden) return WhoRewardedVisibilityTypes.HIDDEN
  else if (isRewardLimited) return WhoRewardedVisibilityTypes.LIMITED
  return WhoRewardedVisibilityTypes.FULL
}

export function getRewardType(reward: Reward, rewardOrder: RewardOrder): WhoRewardedRewardTypes {
  if (reward && reward.legacy) {
    // Old rewards
    if (reward.alt === reward.desc) {
      return WhoRewardedRewardTypes.CUSTOM_OLD_REWARD
    }
    return WhoRewardedRewardTypes.OLD_REWARD
  }

  if (rewardOrder) {
    // New rewards
    if (rewardOrder.custom) {
      return WhoRewardedRewardTypes.CUSTOM_NEW_REWARD
    }
    return WhoRewardedRewardTypes.NEW_REWARD
  }

  return WhoRewardedRewardTypes.NO_REWARD

  // @todo Credit reward
}

export function getUserType(rewardOrder: RewardOrder): WhoRewardedTypes {
  if (rewardOrder && rewardOrder.createdBy) {
    const {uuid} = authentication.user()

    if (uuid === rewardOrder.createdBy.uuid) return WhoRewardedTypes.SENDER

    const isReceiver = rewardOrder.recipients.results.find((user: User) => user.uuid === uuid)
    if (isReceiver) return WhoRewardedTypes.RECEIVER
    return WhoRewardedTypes.VIEWER
  }
  return WhoRewardedTypes.NO_USER
}
